var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-typeset mt-10"},[_c('div',{staticClass:"md-container"},[(_vm.contenta != null)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.contenta)}}):_c('div',[_c('span',{domProps:{"innerHTML":_vm._s('<p3><f1>Başlangıç Sayfası</f1></p3>')}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }